"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderContactFormAndReturnUnmount = void 0;
var contact_form_comp_1 = require("./contact-form.comp");
var utils_1 = require("../utils");
function renderContactFormAndReturnUnmount(elem, props) {
    return utils_1.renderCompAndReturnUnmount(elem, contact_form_comp_1.ContactForm, props);
}
exports.renderContactFormAndReturnUnmount = renderContactFormAndReturnUnmount;
//# sourceMappingURL=contact-form-renderer.js.map